<template>
  <div>
    <ul class="basic-information-icons-list">
      <basic-information-icon v-if="sellingPrices.length === 0" icon="/img/pay-icon.png">
        <h5>
          <base-telephone :phone-number="vendor.phone" class="callNow">call now!</base-telephone>
        </h5>
      </basic-information-icon>

      <basic-information-icon
        v-for="(priceHighlight, index) in sellingPrices"
        :key="index"
        :info="priceHighlight"
      />

      <basic-information-icon v-if="showMilage" :info="highlights.mileage" />
      <basic-information-icon v-if="highlights.gas" :info="highlights.gas" />
      <basic-information-icon v-if="highlights.color" :info="highlights.color" reverse />
    </ul>

    <div class="row basic-info-second-row">
      <div v-for="(detail, index) in details" :key="index" class="col-6 col-sm-4 col-md-auto">
        <h4 class="detail">
          {{ detail.name }}: <span> {{ detail.value }}</span>
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
const PRICE_TYPE = {
  PRICE: 'price',
  RANGE: 'range',
  PAYMENT: 'payment',
};

import BasicInformationIcon from './basic-information-icon';
import BaseTelephone from '@/components/base-telephone';
import { formatMoney, formatMiles } from '@/util/formatters';

export default {
  name: 'VehicleBasicInformation',
  components: {
    BasicInformationIcon,
    BaseTelephone,
  },
  props: {
    vehicle: {
      type: Object,
      required: true,
    },
    vendor: {
      type: Object,
      required: true,
    },
  },
  computed: {
    sellingPrices() {
      return (this.vehicle.selling_price || []).map((price) => {
        return {
          icon: '/img/pay-icon.png',
          title: price.type === PRICE_TYPE.RANGE ? price.value : formatMoney(price.value),
          detail: price.type == PRICE_TYPE.PAYMENT ? 'aprox. monthly payment' : '',
        };
      });
    },
    highlights() {
      const highlights = {};

      if (this.vehicle.exterior_generic_color) {
        highlights.color = {
          icon: '/img/color-icon.png',
          detail: 'Color:',
          title: this.vehicle.exterior_generic_color,
        };
      }

      if (this.vehicle.highway_miles_per_gallon || this.vehicle.city_miles_per_gallon) {
        const highway_mpg = this.vehicle.highway_miles_per_gallon || '';
        const highway_detail = highway_mpg ? 'high-way' : '';

        const city_mpg = this.vehicle.city_miles_per_gallon || '';
        const city_detail = city_mpg ? 'city mpg' : '';

        const title =
          highway_mpg && city_mpg ? `${highway_mpg}/${city_mpg}` : highway_mpg || city_mpg;

        const detail =
          highway_detail && city_detail
            ? `${highway_detail}/${city_detail}`
            : highway_detail || city_detail;

        highlights.gas = {
          icon: '/img/gas-icon.png',
          title,
          detail,
        };
      }

      const mileage = {
        icon: '/img/miles-icon.png',
        title: this.vehicle.mileage >= 0 ? formatMiles(this.vehicle.mileage) : 'N/A',
        detail: 'miles',
      };

      highlights.mileage = mileage;
      return highlights;
    },
    details() {
      return [
        {
          name: 'condition',
          value: this.vehicle.condition,
        },
        {
          name: 'stock',
          value: this.vehicle.stock_number,
        },
        {
          name: 'vin',
          value: this.vehicle.vin,
        },
        {
          name: 'mileage',
          value: formatMiles(this.vehicle.mileage),
        },
        {
          name: 'transmission',
          value: this.vehicle.transmission,
        },
      ].filter((detail) => (detail.name == 'mileage' ? this.showMilage : true));
    },
    showMilage() {
      return !(this.vehicle.mileage == 0 && this.vehicle.condition == 'Used');
    },
  },
};
</script>

<style lang="scss" scoped>
.basic-info-second-row {
  .detail {
    text-transform: uppercase;
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.5rem;

    span {
      text-transform: capitalize;
      font-size: 1rem;
      font-weight: normal;
      display: block;
    }
  }
}
</style>
